// СОСТОЯНИЯ КНОПКИ МИКРОФОНА (ПАНЕЛЬ C, ШАГ 3) — копи, таймер и дев-пресеты. B5-4.
//
// ⛔ ИСТОЧНИК ДВУХ СТРОК — РЕШЕНИЕ `s517.d8`, А НЕ БАЙТ БОРДА, И ИНАЧЕ БЫТЬ НЕ МОЖЕТ. В борде
// состояний (`Life Map - s3 Missing states v3.html`) обе строки нарисованы СЛОТАМИ: на кадре
// видно имя ключа (`wizard.voice.unavailable`), а не текст. Это конвенция CD, а не отставание, и
// решение говорит прямо: «единственное место, где лежит сам текст, — это решение». Отрицательное
// утверждение (обеих строк в борде нет) стоит в парити-тесте с обеих сторон — как у `A11Y_COPY`.
//
// БЮДЖЕТЫ ЗАКРЫТЫ ЗАМЕРОМ, А НЕ СЧЁТОМ ЗНАКОВ (`s518`): 32 из 53 у панельной строки, 24 из 56 у
// полевой, обе мерены рендером при живых шрифтах в настоящих слотах борда. Числа держатся здесь
// утверждением, чтобы правка копи мимо бюджета краснела, а не уезжала на второй строкой.
//
// ⚠️ ДВА КЛАССА ОТКАЗА, ДВА УРОВНЯ (`s517.d1`), И СВОДИТЬ ИХ НЕЛЬЗЯ:
//   · `unavailable` — СОСТОЯНИЕ панели. Причины — нет устройства, небезопасный контекст, нет API;
//     ни одна не чинится внутри визарда. ⚠️ Отказ человека в доступе сюда больше НЕ входит (строка 83,
//     `s1001.d1` меняет `s517.d1`): микрофоны живы, отказ без окна — строка `micOff` у поля.
//     Строка говорится ОДИН РАЗ, там, где стоит подзаголовок панели (кадр `M2`). Каждый микрофон
//     при этом молча показывает, что он выключен — перечёркнутый глиф; именно этот пер-полевой
//     след несёт факт вниз по экрану, когда панельная строка ушла за край (потому и мёртв `M3`).
//   · `transport_failed` — СОБЫТИЕ у поля. Говорится столько раз, сколько полей сорвалось
//     (кадр `M4·2f`: обе строки стоят), но одно поле не складывает две — новая попытка гасит
//     старую. Микрофон при этом НЕ перечёркнут: он и есть повтор, отдельной кнопки нет
//     (`s517.d7`, `wizard.voice.retry` снят вместе с ней).
//
// ⛔ ЧЕГО ЗДЕСЬ НЕТ. Записи, `getUserMedia`, транспорта и молчаливых повторов — всё это блок 5г
// (`3e519875cbb881528587e457354ed989`). Тикет B5-4 просит СОСТОЯНИЯ, достижимые пресетами, и
// прямо говорит: до блока 5г нажатие ничего не делает. Поэтому здесь нет ни одного обращения к
// браузерным возможностям — даже проверки `navigator.mediaDevices`: спросить у браузера значит
// начать делать то, что тикет откладывает.
//
// ⚠️ КАДР `M4·s` ТОЖЕ ЗАКРЫТ, И ЗАКРЫТ ОТСУТСТВИЕМ КОДА. Пока идут молчаливые повторы (1.9 с
// худшего случая), индикатор записи НЕ МЕНЯЕТСЯ — решение дословно «do not change it». Четвёртого
// состояния нет, и это ответ, а не пропуск.

/**
 * Обе строки отказа голоса (`s517.d8`, выбраны Кириллом 20.08).
 *
 * ⚠️ АПОСТРОФ В `transportFailed` — ПРЯМОЙ U+0027, как в самом решении. Долг `s711.d2` сюда не
 * относится: он назван по конкретному Т-ярлыку `didn't allow yourself` в промпте модели, а не по
 * классу символа — тот же критерий, по которому не «чинятся» `what's left` и `don't know` в
 * корпусе панели B.
 */
export const VOICE_COPY = {
  unavailable: 'voice is off here · type instead',
  transportFailed: "that didn't come through",
  /**
   * Браузер отказал в доступе к микрофону БЕЗ окна (строка 83, `s1001.d1`; копи web-Claude 21.10 — «Reload» снят: на
   * iPhone после двух «Нет» перезагрузка доступ не возвращает, только настройки сайта в Safari; проход Кирилла 21.10).
   * Встаёт в слот 56 `s518` одной строкой. Вид — подсказка (`.s3-voiceline.hint`), не сбой: без капса.
   */
  micOff: 'Microphone is off. Allow it in site settings, or type.',
};

/**
 * Бюджеты слотов в символах (`s517.d8`, замер `s518` живыми шрифтами).
 *
 * Панельная строка стоит с отступом 24px и потому не получает полную ширину строки (59); полевая
 * теряет колонку маркера 14px. Числа лежат рядом с текстом, чтобы правка копи проверялась против
 * своего слота, а не против «примерно столько же».
 */
export const VOICE_BUDGET = { unavailable: 53, transportFailed: 56 };

/**
 * Строки живого голоса (Г-4). Источник — решения, не борд:
 *   `finishing` — «Finishing…» под полем, пока ждём финальный проход (`s994.d3`, выбрал Кирилл из трёх);
 *   `limit`     — конец лимита голоса под полем, где он кончился (`s995.d2`); поле живое (`s994.d1`);
 *   `cap`       — «5 min» под иконкой (строка 85; было «3 min»): ожидание потолка записи заранее (`s908.d3` п. 4).
 * Стоп по тишине и по потолку — без строки (`s995.d3`).
 */
export const VOICE_LIVE_COPY = {
  finishing: 'Finishing…',
  limit: 'Voice limit reached for this session. You can keep typing.',
  cap: '5 min',
};

/**
 * Состояния микрофона у поля. B5-4 дал три (покой / запись / недоступно, четвёртого для `M4·s` нет);
 * Г-4 добавил живые: `asking` — висит системное окно разрешения, кнопка ждёт (`s994.d2`);
 * `finishing` — после «стоп», микрофон приглушён (`s994.d3`); `limit` — лимит голоса кончился,
 * микрофон гаснет (`s994.d1`). Вид — минимум до редизайна (`s992.d3`).
 */
export const MIC = { IDLE: 'idle', RECORDING: 'recording', DEAD: 'dead', ASKING: 'asking', FINISHING: 'finishing', LIMIT: 'limit' };

/** Пресет состояний задан в адресе — тогда живой голос не включается (пресет — отладка B5-4). */
export function hasVoicePreset(search = '') {
  try {
    return typeof search === 'string' && new URLSearchParams(search).has('voice');
  } catch {
    return false;
  }
}

/**
 * Состояние микрофона ОДНОГО поля из живого контроллера (`src/wizard/voice/recorder.js`).
 * `active` — это поле сейчас владеет записью (карточка + поле совпали).
 */
export function liveMicState(live, active) {
  if (!live) return MIC.IDLE;
  if (live.unavailable) return MIC.DEAD;
  if (live.limit && !(active && live.phase === 'finishing')) return MIC.LIMIT;
  if (!active) return MIC.IDLE;
  if (live.phase === 'asking') return MIC.ASKING;
  if (live.phase === 'recording') return MIC.RECORDING;
  if (live.phase === 'finishing') return MIC.FINISHING;
  return MIC.IDLE;
}

/** Имена полей панели C. Порядок — борда (`FIELDS`, `:399–401`). */
const FIELD_IDS = ['T1', 'T2', 'T3'];

/**
 * Таймер полосы записи (борд `:624`).
 *
 * ⚠️ РАСХОЖДЕНИЕ С БАЙТОМ НАЗВАНО: борд печатает `0:${SS}` с ЗАШИТЫМ нулём минут, то есть на
 * шестьдесят первой секунде показывает `0:60`. До минуты наша строка совпадает с ним символ в
 * символ (утверждение стоит в тесте), после — считает минуты, как и просит тикет (`MM:SS`).
 * Чинить борд незачем: у него запись имитируется словарём на десяток слов и минуты недостижимы.
 *
 * Минуты БЕЗ ведущего нуля — ровно потому, что до шестидесятой секунды строка обязана быть
 * байтом борда, а `00:14` им не является.
 */
export function mmss(seconds) {
  const s = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/**
 * ДЕВ-ПРЕСЕТ СОСТОЯНИЙ — ТОТ ЖЕ КАНАЛ, ЧТО `?view=wizard`, и по той же причине.
 *
 * Тикет требует, чтобы каждое состояние было СНЯТО пресетом, а живая кнопка при этом ничего не
 * делала. Значит пресету нужен вход, и вход обязан быть один и тот же у теста и у глаза: строка
 * запроса дев-маршрута. Конверт под это не трогается — его форма заморожена (`s864.d1`), и
 * заводить в ней поле под отладку значило бы платить подъёмом версии за дев-переключатель.
 *
 * Грамматика — одна директива:
 *   `?voice=off`             — панель C недоступна целиком (кадр `M2`);
 *   `?voice=rec:T2`          — полоса записи у названного поля (кадр `M4·s` и покой борда);
 *   `?voice=failed:T1,T3`    — сорванная попытка у названных полей (кадры `M4·v2` и `M4·2f`).
 *
 * Неизвестная директива и чужое имя поля молча игнорируются: пресет — отладка, и ронять экран
 * опечаткой в адресе он не имеет права.
 *
 * @param {string} [search] строка запроса (`window.location.search`)
 * @returns {{available: boolean, recording: string|null, failed: string[]}}
 */
export function readVoicePreset(search = '') {
  const idle = { available: true, recording: null, failed: [] };
  if (typeof search !== 'string' || !search) return idle;

  let raw;
  try {
    raw = new URLSearchParams(search).get('voice');
  } catch {
    return idle;
  }
  if (!raw) return idle;

  if (raw === 'off') return { available: false, recording: null, failed: [] };

  const [kind, list = ''] = raw.split(':');
  const names = list.split(',').map((s) => s.trim()).filter((s) => FIELD_IDS.includes(s));
  if (kind === 'rec') return { ...idle, recording: names[0] ?? null };
  if (kind === 'failed') return { ...idle, failed: names };
  return idle;
}

/**
 * Состояние микрофона ОДНОГО поля из пресета.
 *
 * Недоступность сильнее записи: если голоса нет вовсе, писать нечем. Порядок веток здесь и есть
 * это утверждение — и оно проверяется тестом, а не подразумевается порядком строк (ровно тот
 * класс поломки, которым `WizardShell` печатал `continue` вместо надписи закрытого гейта).
 */
export function micState(preset, field) {
  // ⚠️ ПРЕСЕТА НЕТ — ЭТО ПОКОЙ, А НЕ ОТКАЗ. Перечёркнутый глиф — УТВЕРЖДЕНИЕ «голоса нет», и
  // рисовать его от незнания нельзя вдвойне: панельная строка при этом не печатается (её ставит
  // тот же `available`), и получился бы пер-полевой след без факта над ним — ровно то, за что
  // отвергнут кадр `M3`.
  if (!preset) return MIC.IDLE;
  if (preset.available === false) return MIC.DEAD;
  return preset.recording === field ? MIC.RECORDING : MIC.IDLE;
}

/** Показывать ли у поля строку сорванной попытки. Недоступный голос её не печатает: он не пытался. */
export function fieldFailed(preset, field) {
  if (!preset || preset.available === false) return false;
  return Array.isArray(preset.failed) && preset.failed.includes(field);
}
